import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  PPS_CHANGE_DISPLAY_TAB,
  PPS_SET_SUBMIT_MONTH,
  PPS_SET_OTHER_COST_EDITING,
  PPS_RESET_OTHER_COST_EDITING,
  PPS_RESET_ALERT,
  PPS_IS_FETCHING,
  PPS_IMPORT_ACTUAL_REQUEST,
  PPS_FETCH_PROJECTS_SUCCESS,
  PPS_FETCH_PROJECTS_FAILURE,
  PPS_FETCH_PROFIT_SUCCESS,
  PPS_FETCH_PROFIT_FAILURE,
  PPS_UPDATE_PROFIT_SUCCESS,
  PPS_UPDATE_PROFIT_FAILURE,
  PPS_SUBMIT_PROFIT_SUCCESS,
  PPS_SUBMIT_PROFIT_FAILURE,
  PPS_IMPORT_ACTUAL_SUCCESS,
  PPS_IMPORT_ACTUAL_FAILURE,
  PPS_IMPORT_ACTUAL_CLEAR,
  PPS_IMPORT_DETAIL_SUCCESS,
  PPS_IMPORT_DETAIL_FAILURE,
  PPS_DELETE_IMPORT_SUCCESS,
  PPS_DELETE_IMPORT_FAILURE,
  PPS_IMPORT_DETAIL_CLEAR,
  PPS_GET_PROJECT_PROGRESS_REQUEST,
  PPS_GET_PROJECT_PROGRESS_SUCCESS,
  PPS_GET_PROJECT_PROGRESS_FAILURE,
  PPS_GET_PROJECT_PROGRESS_CLEAR,
  PPS_EDIT_PROJECT_PROGRESS_REQUEST,
  PPS_EDIT_PROJECT_PROGRESS_SUCCESS,
  PPS_EDIT_PROJECT_PROGRESS_FAILURE,
  PPS_EDIT_PROJECT_PROGRESS_CLEAR,
  PPS_MANUAL_OPEN,
  PPS_MANUAL_CLOSE,
  PPS_SET_OTHER_COST,
  PPS_SET_PERCENT_TABLE_EXPAND,
  PPS_CAN_SAVE_PROGRESS,
  PPPS_OPEN_RESPONSE_MODAL,
} from '../../constants'

/**
 * @param {string} access_token
 */
export const fetchProjectsData = access_token => ({
  [CALL_API]: {
    endpoint: `${BASE_URL}/project-profits`,
    method: 'GET',
    types: [PPS_IS_FETCHING, PPS_FETCH_PROJECTS_SUCCESS, PPS_FETCH_PROJECTS_FAILURE],
    headers: {
      authorization: `bearer ${access_token}`,
    },
  },
})

/**
 * @param {string} project_id
 * @param {*} month
 * @param {string} access_token
 */
export const fetchProfitData = (project_id, month, access_token) => ({
  [CALL_API]: {
    endpoint: `${BASE_URL}/project-profits/${project_id}${month ? `?month=${month}` : ''}`,
    method: 'GET',
    types: [PPS_IS_FETCHING, PPS_FETCH_PROFIT_SUCCESS, PPS_FETCH_PROFIT_FAILURE],
    headers: {
      authorization: `bearer ${access_token}`,
    },
  },
})

/**
 * @param {string} project_profit_accounting_id
 * @param {string} access_token
 */
export const fetchImportDetail = (project_profit_accounting_id, access_token) => ({
  [CALL_API]: {
    endpoint: `${BASE_URL}/project-profits/accounting/${project_profit_accounting_id}`,
    method: 'GET',
    types: [PPS_IS_FETCHING, PPS_IMPORT_DETAIL_SUCCESS, PPS_IMPORT_DETAIL_FAILURE],
    headers: {
      authorization: `bearer ${access_token}`,
    },
  },
})

/**
 * @param {string} id
 * @param {*} month
 * @param {string} remark
 * @param {string} access_token
 */
export const submitProfitData = (id, month, remark, access_token) => ({
  [CALL_API]: {
    endpoint: `${BASE_URL}/project-profits/${id}/${month}/submit`,
    method: 'POST',
    types: [PPS_IS_FETCHING, PPS_SUBMIT_PROFIT_SUCCESS, PPS_SUBMIT_PROFIT_FAILURE],
    headers: {
      authorization: `bearer ${access_token}`,
    },
    body: JSON.stringify({ remark }),
  },
})

/**
 * @param {FormData} data csv, remark, is_submit
 * @param {string} access_token
 */
export const importActualCost = (data, access_token) => ({
  [CALL_API]: {
    endpoint: `${BASE_URL}/project-profits/transaction/imports`,
    method: 'POST',
    types: [PPS_IMPORT_ACTUAL_REQUEST, PPS_IMPORT_ACTUAL_SUCCESS, PPS_IMPORT_ACTUAL_FAILURE],
    headers: {
      authorization: `bearer ${access_token}`,
    },
    body: data,
  },
})

/**
 * @param {string} project_id
 * @property {*} other_costs
 * @param {string} access_token
 */
export const updateOtherCost = (project_id, other_costs, access_token) => ({
  [CALL_API]: {
    endpoint: `${BASE_URL}/project-profits/other-cost/${project_id}`,
    method: 'PUT',
    types: [PPS_IS_FETCHING, PPS_UPDATE_PROFIT_SUCCESS, PPS_UPDATE_PROFIT_FAILURE],
    headers: {
      authorization: `bearer ${access_token}`,
    },
    body: JSON.stringify({ other_costs }),
  },
})

/**
 * @param {string} accounting_id
 * @param {string} access_token
 */
export const deleteImportTransactions = (accounting_id, access_token) => ({
  [CALL_API]: {
    endpoint: `${BASE_URL}/project-profits/accounting-transaction/${accounting_id}`,
    method: 'DELETE',
    types: [PPS_IS_FETCHING, PPS_DELETE_IMPORT_SUCCESS, PPS_DELETE_IMPORT_FAILURE],
    headers: {
      authorization: `bearer ${access_token}`,
    },
    body: JSON.stringify({ commit: true }),
  },
})

/**
 * @param {string} access_token
 */
export const fetchProjectProgress = (id, month, access_token) => ({
  [CALL_API]: {
    endpoint: `${BASE_URL}/project-progresses/${id}?month=${month}`,
    method: 'GET',
    types: [PPS_GET_PROJECT_PROGRESS_REQUEST, PPS_GET_PROJECT_PROGRESS_SUCCESS, PPS_GET_PROJECT_PROGRESS_FAILURE],
    headers: {
      authorization: `bearer ${access_token}`,
    },
  },
})

/**
 * @param {string} project_id
 * @property {*} other_costs
 * @param {string} access_token
 */
export const updateProjectProgress = (id, progresses, access_token) => ({
  [CALL_API]: {
    endpoint: `${BASE_URL}/project-progresses/${id}`,
    method: 'PUT',
    types: [PPS_EDIT_PROJECT_PROGRESS_REQUEST, PPS_EDIT_PROJECT_PROGRESS_SUCCESS, PPS_EDIT_PROJECT_PROGRESS_FAILURE],
    headers: {
      authorization: `bearer ${access_token}`,
    },
    body: JSON.stringify({ progresses }),
  },
})

/**
 * @param {string} name
 */
export const changeDisplayTab = name => ({
  type: PPS_CHANGE_DISPLAY_TAB,
  payload: name,
})

/**
 * @param {import('moment').Moment} date
 */
export const setSubmitMonth = date => ({
  type: PPS_SET_SUBMIT_MONTH,
  payload: date,
})

export const setOtherCost = payload => ({
  type: PPS_SET_OTHER_COST,
  payload,
})

/**
 * @param {import('immutable').List} data
 */
export const setOtherCostEditing = data => ({
  type: PPS_SET_OTHER_COST_EDITING,
  payload: data,
})

export const setPercentTable = payload => ({
  type: PPS_SET_PERCENT_TABLE_EXPAND,
  payload,
})

export const setCanSaveProgress = data => ({
  type: PPS_CAN_SAVE_PROGRESS,
  payload: data,
})

export const resetOtherCostEditing = () => ({
  type: PPS_RESET_OTHER_COST_EDITING,
})

export const resetImportActual = () => ({
  type: PPS_IMPORT_ACTUAL_CLEAR,
})

export const resetImportDetail = () => ({
  type: PPS_IMPORT_DETAIL_CLEAR,
})

export const resetAlert = () => ({
  type: PPS_RESET_ALERT,
})

export const resetProjectProgresses = () => ({
  type: PPS_GET_PROJECT_PROGRESS_CLEAR,
})

export const resetEditProgresses = () => ({
  type: PPS_EDIT_PROJECT_PROGRESS_CLEAR,
})

export const openManual = () => ({
  type: PPS_MANUAL_OPEN,
})

export const closeManual = () => ({
  type: PPS_MANUAL_CLOSE,
})

export function openResponseModal(payload) {
  return {
    type: PPPS_OPEN_RESPONSE_MODAL,
    payload,
  }
}



// WEBPACK FOOTER //
// ./src/actions/project-profit-sheet/pps-action.js